import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled, css } from 'styled-components';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id';
import { Tooltip } from '../../V2/Feedback/Tooltip';
import { Radio, Container as RadioContainer, Label as RadioLabel } from '../Radio';
export const RadioGroupWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -10px;

  ${({ $vertical }) => $vertical &&
    css `
      flex-direction: column;
      align-items: flex-start;
    `}

  ${RadioContainer} {
    margin: 10px;
  }
`;
const defaultLabelFormat = ({ label }) => label;
const defaultIsOptionSelected = (option, selected) => option === selected;
export const RadioGroup = ({ className, onChange, options, value, name, fakePrefix, disabled = false, formatOptionLabel = defaultLabelFormat, getOptionTooltip, dataTestId, isOptionSelected = defaultIsOptionSelected, vertical, }) => {
    const innerName = React.useMemo(() => (fakePrefix ? `${name}_${fakePrefix}` : name), [name, fakePrefix]);
    return (_jsxs(RadioGroupWrapper, { className: className, "$vertical": vertical, "data-testid": dataTestId, children: [fakePrefix && _jsx("input", { name: name, type: 'hidden' }), options.map((option) => {
                const radio = (_jsx(Radio, { name: innerName, onChange: (e) => onChange(option, e), checked: isOptionSelected(option, value), disabled: disabled, dataTestId: `${innerName ? `${innerName}-` : ''}${getDataTestId(formatOptionLabel(option))}-${isOptionSelected(option, value)}`, children: _jsx(RadioLabel, { children: formatOptionLabel(option) }) }, option.label));
                if (getOptionTooltip) {
                    const tooltip = getOptionTooltip(option);
                    if (tooltip) {
                        return (_jsx(Tooltip, { placement: vertical ? 'right' : 'top', tooltip: getOptionTooltip(option), dataTestId: 'tooltip-popup', children: radio }, option.label));
                    }
                }
                return radio;
            })] }));
};
